import React from 'react';
import { useState, useRef, useContext } from 'react';
import { useNavigate } from 'react-router-dom';


import Modal from '../../../components/UI/Modal/Modal'
import API from '../../../lib/api';
// import AuthContext from '../../store/auth-context';
import { login } from '../../../components/util/auth';

import styles from './AuthForm.module.css';

const AuthForm = () => {
  const navigate = useNavigate();
  const emailInputRef = useRef();
  const passwordInputRef = useRef();
  const passwordConfirmationInputRef = useRef();

  //const authCtx = useContext(AuthContext);

  const [isLogin, setIsLogin] = useState(true);
  const [isReset, setIsReset] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState( null );
  const [msg, setMsg] = useState( null );

  const switchAuthModeHandler = () => {
    setIsLogin((prevState) => !prevState);
    setIsReset( false );
  };

  const resetPwdHandler = () => {
    setIsLogin( false );
    setIsReset( true );
  };

  const submitHandler = (event) => {
    event.preventDefault();

    const enteredEmail = emailInputRef.current.value;
    
    if (isReset) {
      const dataReset = {
        submitter: {
          email: enteredEmail
        }        
      }
      const cfg = API.crsf_cfg()

      API.req( 'submitters/password', 'post', dataReset, cfg )
      .then((data) => {
        setIsLoading(false);
        setMsg('Sie erhalten die Anweisungen zum Zurücksetzen des Passwortes per E-Mail');
      })
      .catch( (err) => {
        setIsLoading(false);
        setErrorMsg(err.message);
        console.log( err.message )
      });
      
    } else {

      const enteredPassword = passwordInputRef.current.value;
      let enteredPasswordConfirmation='';
      
      if (!isLogin) {
        enteredPasswordConfirmation = passwordConfirmationInputRef.current.value; 
        
        if ( enteredPassword !== enteredPasswordConfirmation ) {
          setErrorMsg("Passwords do not match");
          return;
        }
      }
      
      setIsLoading(true);
      
//      const url_login = `${API.logIn}?grant_type=password&email=${enteredEmail}&password=${enteredPassword}`;
//      const data_login = {}
      const url_login = `${API.logIn}`;
      const data_login = {
              grant_type: 'password',
              email: enteredEmail, 
              password: enteredPassword
            }
      
      if( !isLogin ) {
        const url_signup = API.signUp;
        const data_signup = {
          submitter: {
            email: enteredEmail,
            password: enteredPassword,
            password_confirmation: enteredPasswordConfirmation
          }        
        }
        API.req( url_signup, 'post', data_signup )
        .then((data) => {
          console.log("Account created")
          API.req( url_login, 'post', data_login )
          .then((data) => {
            const expirationTime = new Date(
              new Date().getTime() + +data.expires_in * 1000
            );
            //authCtx.login(data.access_token, expirationTime.toISOString());
            login(data.access_token, expirationTime.toISOString(), true);
            setIsLoading(false);
            navigate('/submit/');
            })
            .catch( (err) => { // login req
              setIsLoading(false);
              setErrorMsg( err.message );
              console.log( err.message )
            });
          })
          .catch( (err) => { // signup req
            setIsLoading(false);
            setErrorMsg( err.message );
            console.log( err.message )
          });
      } else {
        API.req( url_login, 'post', data_login )
        .then((data) => {
          const expirationTime = new Date(
            new Date().getTime() + +data.expires_in * 1000
          );
          //authCtx.login(data.access_token, expirationTime.toISOString());
          console.log( '[Login] ', data.access_token, data.expires_in, expirationTime.toISOString())
          login(data.access_token, expirationTime.toISOString(), false);
          setIsLoading(false);
          navigate('/submit/');
        })
        .catch( (err) => {
          setIsLoading(false);
          setErrorMsg( err.message );
          console.log( err.message )
        });  
        } // isLogin
    } // isReset
};
        
  let title = isLogin ? 'Anmelden' : 'Registrieren';
  let submitText = isLogin ? 'Anmelden' : 'Neues Konto anlegen';
  if ( isReset ) {
    title = 'Passwort zurücksetzen';
    submitText = 'Passwort zurücksetzen'
  } 

  return (
    <section className={styles.auth}>
      { msg && 
        <Modal show={!!msg}
          modalClosed={() => { setMsg(null) }}
          className = 'success'>
            <div>{msg}</div>
        </Modal>
      }
      { errorMsg && 
        <Modal show={!!errorMsg}
          modalClosed={() => { setErrorMsg(null) }}
          className = 'error'>
           <div>{errorMsg}</div>
        </Modal>
      }
      <h1>{title}</h1>
      <form onSubmit={submitHandler}>
        <div className={styles.control}>
          <label htmlFor='email'>Ihre E-Mail Adresse</label>
          <input type='email' id='email' required ref={emailInputRef} />
        </div>
        { 
          !isReset && 
          <div className={styles.control}>
            <label htmlFor='password'>Ihr Passwort</label>
            <input
              type='password'
              id='password'
              required
              ref={passwordInputRef}
            />
          </div>
        }
        { 
          (!isLogin && !isReset) && 
          <div className={styles.control}>
            <label htmlFor='password'>Wiederholen Sie Ihr Passwort</label>
            <input
              type='password'
              id='password_confirmation'
              required
              ref={passwordConfirmationInputRef}
            />
            <small className={styles.legal}>
            Indem Sie auf "Neues Konto anlegen" klicken, stimmen Sie 
            den <a href="https://www.findme2care.de/nutzungsbedingungen-fuer-patientinnen-und-patienten/" target="_blank">Nutzungsbedingungen für Patientinnen und Patienten</a> von 
            FindMe2care zu. In 
            unserer <a href="https://www.findme2care.de/datenschutz/" target="_blank">Datenschutzinformation für Patientinnen und Patienten</a> erfahren
            Sie, wie wir Daten verarbeiten. 
            Die Einwilligung zur Übermittlung der medizinischen Daten geben Sie gesondert bei der Registrierung des Befundes.
            </small>
          </div>
        }
        <div className={styles.actions}>
          {!isLoading && (
            <button>{submitText}</button>
          )}
          {isLoading && <p>Sending request...</p>}
          <div style={{marginTop: '20px'}}>
          { isLogin 
            ? 'Sie sind zum ersten Mal auf dieser Seite? Dann registrieren Sie sich bitte als neuer User:' 
            : 'Sie haben schon ein Benutzerkonto? Dann melden Sie sich hier an:' }
          </div>
          <button
              type='button'
              className={styles.toggle}
              onClick={switchAuthModeHandler}
            >
              { isLogin ? 'Neues Konto anlegen' : 'Mit bestehendem Konto anmelden' }
          </button>
          { isLogin && <button
              type='button'
              className={[styles.toggle, styles.skip].join(' ')}
              onClick={resetPwdHandler}
            >
              Passwort zurücksetzen
            </button>
          }
        </div>
      </form>
    </section>
  );
};

export default AuthForm;
